import React  from "react";
import { useParams } from 'react-router-dom';
import ClientTeamForm from "./components/ClientTeamForm";
import Card from "components/card";

const EditClientTeam = () => {

	const { clientId, teamId } = useParams();

	return (
	    <div>
	    	<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
      				<ClientTeamForm clientId={clientId} recordId={teamId} mode="edit"/>
	      		</div>
	    	</Card>
	    </div>
    );
};

export default EditClientTeam;